import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'


export const Famille = () => (
    <DataView module={Constants.module.GESTION} object={Constants.donnee.famille}/>
)

export default Famille



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Gestion/Famille/index.js